import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import { useCompany } from '@/lib/CompanyProvider'

export function useCompanyMutation<
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(options: UseMutationOptions<TData, TError, TVariables & { company_id?: string }, TContext>) {
  const { activeCompanyId } = useCompany()

  const mutationFn = async (variables?: any) => {
    if (!options.mutationFn) {
      throw new Error('mutationFn is required in useCompanyMutation')
    }

    if (!activeCompanyId) {
      throw new Error('Nenhuma empresa selecionada no contexto multi-tenant.')
    }

    // Injeta o company_id silenciosamente se ele não foi enviado explicitly
    const vars = variables || {}
    const variablesWithCompany = {
      ...vars,
      company_id: vars.company_id || activeCompanyId,
    }

    return (options.mutationFn as any)(variablesWithCompany)
  }

  return useMutation({
    ...options,
    mutationFn,
  }) as any
}
